import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography
} from '@mui/material';
import api from '../services/api';

interface ForgotPasswordProps {
    open: boolean;
    onClose: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ open, onClose }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSend = async () => {
        setLoading(true);
        setMessage('');
        try {
            await api.post('/auth/forgot-password', { email });
            setMessage('Se o e-mail estiver cadastrado, você receberá instruções para redefinir sua senha.');
        } catch (error: any) {
            setMessage(error.response?.data?.error || 'Erro ao solicitar recuperação de senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Esqueci minha senha</DialogTitle>
            <DialogContent>
                <Typography>Informe seu e-mail cadastrado para receber instruções de recuperação:</Typography>
                <TextField
                    label="E-mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                {message && (
                    <Typography color={message.startsWith('Se') ? 'primary' : 'error'} sx={{ mt: 2 }}>
                        {message}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleSend} variant="contained" color="primary" disabled={loading || !email}>
                    {loading ? 'Enviando...' : 'Enviar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ForgotPassword;